
import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { Link, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { fetchData } from "../helper/api.interceptor"; // Update the path to your api utils
import './banner.scss';

const Banners = () => {
    const navigate = useNavigate();
    const [banners, setBanners] = useState([]);
    const [newBanner, setNewBanner] = useState({
        title: '',
        image: null,
        imagePreview: null
    });
    const [isLoading, setIsLoading] = useState(false);

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                setNewBanner({
                    ...newBanner,
                    image: file,
                    imagePreview: reader.result
                });
            };
            reader.readAsDataURL(file);
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewBanner({
            ...newBanner,
            [name]: value
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        if (!newBanner.image || !newBanner.title) {
            Swal.fire({
                title: 'Missing Information',
                text: 'Please provide both a title and an image',
                icon: 'warning'
            });
            setIsLoading(false);
            return;
        }

        try {
            const formData = new FormData();
            formData.append('title', newBanner.title);
            formData.append('image', newBanner.image);

            const response = await fetchData.postWithFormData('/add-banners', formData);
            console.log("addd" + response);


            if (response && response.status_code == 200) {
                // Add the new banner to the local state (optional)
                setBanners(prev => [{
                    id: response.data?.id || Date.now(),
                    title: newBanner.title,
                    imageUrl: response.data?.imageUrl || URL.createObjectURL(newBanner.image),
                    createdAt: new Date().toLocaleString()
                }, ...prev]);

                Swal.fire({
                    title: 'Success!',
                    text: 'Banner has been added successfully',
                    icon: 'success',
                    confirmButtonText: 'OK'
                }).then(() => {

                    navigate("/offer-banner/view");
                });

                // Reset form
                setNewBanner({
                    title: '',
                    image: null,
                    imagePreview: null
                });
                e.target.reset();
            } else {
                throw new Error(response?.message || 'Failed to add banner');
            }
        } catch (error) {
            console.error('Error adding banner:', error);
            Swal.fire({
                title: 'Error!',
                text: error.message || 'Failed to add banner',
                icon: 'error',
                confirmButtonText: 'OK'
            });
        } finally {
            setIsLoading(false);
        }
    };

    const removeBanner = async (id) => {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const response = await fetchData.delete(`/api/v1/banners/${id}`);

                    if (response && response.success) {
                        setBanners(banners.filter(banner => banner.id !== id));
                        Swal.fire('Deleted!', 'Your banner has been deleted.', 'success');
                    } else {
                        throw new Error(response?.message || 'Failed to delete banner');
                    }
                } catch (error) {
                    console.error('Error deleting banner:', error);
                    Swal.fire('Error!', error.message || 'Failed to delete banner', 'error');
                }
            }
        });
    };

    return (
        <div className="banner-management-container">
            <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-4">
                <h6 className="fw-semibold mb-0">Add Banners</h6>
                <ul className="d-flex align-items-center gap-2 list-unstyled mb-0">
                    <li className="fw-medium">
                        <Link to="/offer-banner/view" className="d-flex align-items-center gap-1 text-decoration-none text-muted hover-text-primary">
                            <Icon icon="solar:home-smile-angle-outline" className="text-lg" />
                            Offer Banners
                        </Link>
                    </li>
                    <li>-</li>
                    <li className="fw-medium text-dark">Add Banners</li>
                </ul>
            </div>
            <div className="banner-form-card">
                <h3 className="form-title">Add New Banner</h3>

                <form onSubmit={handleSubmit} className="banner-form">
                    <div className="form-group">
                        <label htmlFor="banner-title">Banner Title</label>
                        <input
                            type="text"
                            id="banner-title"
                            name="title"
                            value={newBanner.title}
                            onChange={handleInputChange}
                            placeholder="Enter banner title"
                            required
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="banner-image">Banner Image</label>
                        <div className="image-upload-container">
                            {newBanner.imagePreview ? (
                                <div className="image-preview">
                                    <img src={newBanner.imagePreview} alt="Preview" />
                                    <button
                                        type="button"
                                        className="change-image-btn"
                                        onClick={() => setNewBanner({ ...newBanner, image: null, imagePreview: null })}
                                    >
                                        Change Image
                                    </button>
                                </div>
                            ) : (
                                <label className="upload-area">
                                    <Icon icon="solar:upload-linear" className="upload-icon" />
                                    <span>Click to upload image</span>
                                    <input
                                        type="file"
                                        id="banner-image"
                                        accept="image/*"
                                        onChange={handleFileChange}
                                        required
                                        hidden
                                    />
                                    <p className="file-requirements">Supports JPG, PNG (Max 5MB)</p>
                                </label>
                            )}
                        </div>
                    </div>

                    <button type="submit" className="submit-btn" disabled={isLoading}>
                        {isLoading ? (
                            <span>Adding...</span>
                        ) : (
                            <>
                                <Icon icon="mdi:plus" />
                                Add Banner
                            </>
                        )}
                    </button>
                </form>
            </div>

            <style jsx>{`
                .banner-management-container {
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 2rem;
                }

                .header-section {
                    margin-bottom: 2rem;
                }

                .page-title {
                    font-size: 1.75rem;
                    font-weight: 600;
                    color: #1a1a1a;
                    margin-bottom: 0.5rem;
                }

                .page-description {
                    color: #64748b;
                    margin: 0;
                }

                .banner-form-card {
                    background: #ffffff;
                    border-radius: 0.75rem;
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
                    padding: 1.5rem;
                    margin-bottom: 2rem;
                }

                .form-title {
                    font-size: 1.25rem;
                    font-weight: 600;
                    color: #1a1a1a;
                    margin-bottom: 1.5rem;
                }

                .banner-form {
                    display: flex;
                    flex-direction: column;
                    gap: 1.5rem;
                }

                .form-group {
                    display: flex;
                    flex-direction: column;
                    gap: 0.5rem;
                }

                .form-group label {
                    font-weight: 500;
                    color: #334155;
                }

                .form-group input[type="text"] {
                    padding: 0.75rem;
                    border: 1px solid #e2e8f0;
                    border-radius: 0.5rem;
                    font-size: 1rem;
                    transition: border-color 0.2s;
                }

                .form-group input[type="text"]:focus {
                    outline: none;
                    border-color: #3b82f6;
                    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
                }

                .image-upload-container {
                    margin-top: 0.5rem;
                }

                .upload-area {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    border: 2px dashed #cbd5e1;
                    border-radius: 0.5rem;
                    padding: 2rem;
                    cursor: pointer;
                    transition: all 0.2s;
                    text-align: center;
                }

                .upload-area:hover {
                    border-color: #94a3b8;
                    background-color: #f8fafc;
                }

                .upload-icon {
                    font-size: 2rem;
                    color: #94a3b8;
                    margin-bottom: 0.5rem;
                }

                .file-requirements {
                    color: #64748b;
                    font-size: 0.875rem;
                    margin-top: 0.5rem;
                }

                .image-preview {
                    position: relative;
                    border: 1px solid #e2e8f0;
                    border-radius: 0.5rem;
                    overflow: hidden;
                }

                .image-preview img {
                    width: 100%;
                    max-height: 200px;
                    object-fit: contain;
                }

                .change-image-btn {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    background: rgba(0, 0, 0, 0.7);
                    color: white;
                    border: none;
                    padding: 0.5rem;
                    cursor: pointer;
                    transition: background 0.2s;
                }

                .change-image-btn:hover {
                    background: rgba(0, 0, 0, 0.8);
                }

                .submit-btn {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    gap: 0.5rem;
                    padding: 0.75rem 1.5rem;
                    background-color: #3b82f6;
                    color: white;
                    border: none;
                    border-radius: 0.5rem;
                    font-weight: 500;
                    cursor: pointer;
                    transition: all 0.2s;
                    margin-top: 1rem;
                }

                .submit-btn:hover {
                    background-color: #2563eb;
                    transform: translateY(-1px);
                }

                .banners-list {
                    background: #ffffff;
                    border-radius: 0.75rem;
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
                    padding: 1.5rem;
                }

                .list-title {
                    font-size: 1.25rem;
                    font-weight: 600;
                    color: #1a1a1a;
                    margin-bottom: 1.5rem;
                }

                .empty-state {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    padding: 3rem;
                    text-align: center;
                    color: #64748b;
                }

                .empty-icon {
                    font-size: 3rem;
                    margin-bottom: 1rem;
                    color: #cbd5e1;
                }

                .banner-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
                    gap: 1.5rem;
                }

                .banner-card {
                    background: #ffffff;
                    border-radius: 0.5rem;
                    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
                    overflow: hidden;
                    transition: all 0.3s ease;
                    position: relative;
                }

                .banner-card:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
                }

                .banner-image {
                    height: 180px;
                    overflow: hidden;
                }

                .banner-image img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }

                .banner-details {
                    padding: 1rem;
                }

                .banner-title {
                    font-size: 1rem;
                    font-weight: 600;
                    color: #1a1a1a;
                    margin-bottom: 0.5rem;
                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .upload-date {
                    color: #64748b;
                    font-size: 0.875rem;
                    margin: 0;
                }

                .delete-btn {
                    position: absolute;
                    top: 0.5rem;
                    right: 0.5rem;
                    background: rgba(239, 68, 68, 0.9);
                    color: white;
                    border: none;
                    width: 32px;
                    height: 32px;
                    border-radius: 50%;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    transition: all 0.2s;
                }

                .delete-btn:hover {
                    background: #dc2626;
                    transform: scale(1.1);
                }

                @media (max-width: 768px) {
                    .banner-management-container {
                        padding: 1rem;
                    }

                    .banner-grid {
                        grid-template-columns: 1fr;
                    }
                }
            `}</style>
        </div>
    );
};

export default Banners;